import axios from "axios";
import Swal from "sweetalert2";
import { getLocalStorage } from "./localStorage";
import ApiPermissions from '../api/ApiPermissions'
import { useEffect, useRef } from "react";
var url = require('url');
var path = require('path');
// check if an element exists in array using a comparer function
// comparer : function(currentElement)
Array.prototype.inArray = function (comparer) {
  for (var i = 0; i < this.length; i++) {
    if (comparer(this[i])) return true;
  }
  return false;
};

// adds an element to the array if it does not already exist using a comparer
// function
Array.prototype.pushIfNotExist = function (element, comparer) {
  if (!this.inArray(comparer)) {
    this.push(element);
  }
};

export const setHeaderAuth = async () => {
  const token = await getLocalStorage("tokenBackoffice");
  if (token) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  }
};

export function checkFormatIdCard(p_iPID) {
  let isSuccess = true;
  var total = 0;
  var iPID;
  var chk;
  var Validchk;
  iPID = p_iPID.replace(/-/g, "");
  Validchk = iPID.substr(12, 1);
  var j = 0;
  var pidcut;
  for (var n = 0; n < 12; n++) {
    pidcut = parseInt(iPID.substr(j, 1));
    total = total + pidcut * (13 - n);
    j++;
  }

  chk = 11 - (total % 11);

  if (chk == 10) {
    chk = 0;
  } else if (chk == 11) {
    chk = 1;
  }
  if (chk == Validchk) {
    isSuccess = true;
  } else {
    isSuccess = false;
  }
  return isSuccess;
}

export function autoTabRazor(obj) {
  /* กำหนดรูปแบบข้อความโดยให้ _ แทนค่าอะไรก็ได้ แล้วตามด้วยเครื่องหมาย 
  หรือสัญลักษณ์ที่ใช้แบ่ง เช่นกำหนดเป็น  รูปแบบเลขที่บัตรประชาชน 
  4-2215-54125-6-12 ก็สามารถกำหนดเป็น  _-____-_____-_-__ 
  รูปแบบเบอร์โทรศัพท์ 08-4521-6521 กำหนดเป็น __-____-____ 
  หรือกำหนดเวลาเช่น 12:45:30 กำหนดเป็น __:__:__ 
  ตัวอย่างข้างล่างเป็นการกำหนดรูปแบบเลขบัตรประชาชน 
  */
  var pattern = new String("___-_______-__"); // กำหนดรูปแบบในนี้
  var pattern_ex = new String("-"); // กำหนดสัญลักษณ์หรือเครื่องหมายที่ใช้แบ่งในนี้
  var returnText = new String("");
  var obj_l = obj.length;
  var obj_l2 = obj_l - 1;
  for (var i = 0; i < pattern.length; i++) {
    if (obj_l2 == i && pattern.charAt(i + 1) == pattern_ex) {
      returnText += obj + pattern_ex;
      obj = returnText;
    }
  }
  if (obj_l >= pattern.length) {
    obj = obj.substr(0, pattern.length);
  }

  return obj;
}

export function statusSurveyText(item) {
  if (
    item.isconclude === "O" &&
    item.date_balance < 0 &&
    item.public_status === "P"
  ) {
    return "ปิดรับฟัง";
  } else if (
    item.isconclude === "O" &&
    item.date_balance < 0 &&
    item.public_status !== "P"
  ) {
    return "ปิดรับฟัง (ไม่ได้เผยแพร่)";
  }
  if (item.isconclude !== "O") {
    if (item.public_status !== "P") {
      return "ปิดรับฟัง (ไม่ได้เผยแพร่)";
    }
    if (item.date_balance >= 0) {
      return "ปิดรับฟัง ก่อนกำหนด";
    }
    return "ปิดรับฟัง";
  } else {
    if (item.public_status == "P") {
      if (item.date_balance < 0) {
        return "ปิดรับฟัง";
      }
      return "เปิดรับฟัง";
    } else {
      return "รอการเผยแพร่";
    }
  }
}

export const checkComplete = (item) => {

  if (item.isconclude == "O" || !item.isconclude) {
    if (item.date_balance > item.duration_day) {
      return 0;
    } else {
      return (
        ((item.duration_day - item.date_balance) / item.duration_day) * 100
      );
    }
  } else {
    return 100;
  }
};
export const checkLeftTime = (item) => {
  if (item.isconclude == "O" || !item.isconclude) {
    if (item.date_balance < 0) {
      return "ปิดการรับฟัง";
    } else {
      return `เหลือ ${item.date_balance} วัน`;
    }
  } else if (item.isconclude == "D") {
    return "อยู่ระหว่างการสรุปผล";
  } else if (item.isconclude == "C") {
    return "ไม่มีการสรุปผล";
  } else if (item.isconclude == "B") {
    return "ปิดรับฟังก่อนกำหนด";
  }
  else if (item.isconclude == "P") {
    return "เผยแพร่สรุปผลการรับฟัง";
  }
};



export const checkCardBackground = (item) => {
  if (item.isconclude == "O" || !item.isconclude) {
    if (item.date_balance < 0) {
      return { background: "rgb(228, 232, 240)", boxShadow: "none" };
    } else {
      return {};
    }
  } else if (item.isconclude == "D") {
    return { background: "rgb(228, 232, 240)", boxShadow: "none" };
  } else if (item.isconclude == "C") {
    return { background: "rgb(228, 232, 240)", boxShadow: "none" };
  } else if (item.isconclude == "B") {
    return { background: "rgb(228, 232, 240)", boxShadow: "none" };
  }
  else if (item.isconclude == "P") {
    return { background: "rgb(228, 232, 240)", boxShadow: "none" };
  }
};

export const checkAccessRight = (access_right = 0) => {
  if (access_right == 1) {
    return "ทั่วไป (ไม่จำกัด)"
  }
  else if (access_right == 2) {
    return "ม.19"
  }
  else if (access_right == 3) {
    return "ทั่วไป (ลงทะเบียน)"
  }
  else if (access_right == 4) {
    return "ทั่วไป (ยืนยันตัวตน)"
  } else {
    return "ทั่วไป (ไม่จำกัด)"
  }
};

export const checkContentLawType = (type = "") => {
  if (type == "หมวด" || type == "ส่วน" || type == "ตอน" || type == "บรรพ") {
    return "center"
  }
  else {
    return "left"
  }
};

export const ApiPermissionRequestMiddleWare = async ({ page_code = "" }) => {
  try {
    await ApiPermissions.get(page_code);
  } catch (error) {

  }
}

export const encodeBase64 = (text = '') => {
  const textKey = 'DGA_LAW_FRONTEND';
  const decode = Buffer.from(text + textKey).toString('base64');
  return decode;
};

export const showLoading = () => {
  return Swal.fire({
    title: 'Please Wait !',
    html: 'data uploading',// add html attribute if you want or remove
    allowOutsideClick: false,
    onBeforeOpen: () => {
      Swal.showLoading()
    },
  });
}

export const numberToThai = (value) => {
  let newValue = "";
  const arrayThai = ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"]
  const arrayNumber = value.toString().split('');
  arrayNumber.map((item, index) => {
    if (item == ".") {
      newValue += ".";
    }
    else if (item == "/") {
      newValue += "/";
    }
    else if (item == "-") {
      newValue += "-";
    }
    else if (item == "") {
      newValue += "";
    } else {
      newValue += arrayThai[parseInt(item)];
    }
  });
  return newValue;
}

export const useWindowUnloadEffect = (handler, callOnCleanup) => {
  const cb = useRef();

  cb.current = handler;

  useEffect(() => {
    const handler = () => cb.current();

    window.addEventListener('beforeunload', handler);

    return () => {
      if (callOnCleanup) handler();

      window.removeEventListener('beforeunload', handler);
    };
  }, [cb]);
};

export const ParseUrlToFileName = (url_file = '') => {
  if (!url_file) {
    return '';
  }
  var parsed = url.parse(url_file);
  return path.basename(parsed.pathname);
};
